import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../features/auth/authSlice';

export default function NoAuthRoute({ component: Component, location, ...rest }) {
  const user = useSelector(selectUser);

  return (
    <Route
      {...rest}
      render={(props) =>
        !user ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: location?.state?.from?.pathname ?? '/',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}
